import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { API_URL_SERVER } from '../../api/api';
import { AuthContext } from '../../context/AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';

const OrderHistory = () => {
    const { isAuthenticated } = useContext(AuthContext);
    const [orders, setOrders] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        if (isAuthenticated) {
            fetchOrders();
        }
    }, [isAuthenticated]);

    const fetchOrders = async () => {
        try {
            // Replace with your actual endpoint
            const response = await axios.get(`${API_URL_SERVER}/orders`);
            setOrders(response.data);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch orders');
        }
    };

    if (!isAuthenticated) {
        return null; // ProtectedRoute will handle redirect
    }

    return (
        <div className="container mt-5">
            <h2>Order History</h2>
            {error && <div className="alert alert-danger">{error}</div>}
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Order ID</th>
                        <th>Date</th>
                        <th>Details</th>
                    </tr>
                </thead>
                <tbody>
                    {orders.map((order) => (
                        <tr key={order.id}>
                            <td>{order.id}</td>
                            <td>{order.date}</td>
                            <td>{order.details}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default OrderHistory;